module.exports = __webpack_public_path__ + "img/swiper_img1.d33d833c.webp";